import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    active: {
        color: "#3F51B5",
        fontWeight: 700,
        backgroundColor: "lightgrey"
    },
    inactive: {
        fontSize: "1rem",
        marginTop: "10px"
    }
}));

export { useStyles };